import type { ReactNode } from 'react';
import styled from 'styled-components';

import type { Skin } from '@sorare/core/src/__generated__/globalTypes';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';

const HEX_CLIP =
  'polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%)';

const Root = styled.div`
  position: relative;
  width: 57px;
  height: 66px;
`;
const HexFill = styled.div`
  position: absolute;
  inset: 0;
  clip-path: ${HEX_CLIP};

  &.shiny {
    background: var(--c-gradient-shiny);
  }
  &.holo {
    background: var(--c-gradient-holo);
  }
  &.full_art {
    background: var(--c-gradient-legendary);
  }
`;
const Children = styled(Horizontal).attrs({ center: true })`
  width: 100%;
  position: absolute;
  inset: 0;
  align-items: center;
`;

type Props = { children?: ReactNode; skin: Skin };

export const SpecialEditionHexagon = ({ children, skin }: Props) => {
  return (
    <Root>
      <HexFill className={skin.toLowerCase()} />
      {!!children && <Children>{children}</Children>}
    </Root>
  );
};
